import React from 'react';
import { cn } from '@/utils/style';
interface IProps {
  className?: string;
  children: React.ReactNode;
  [key: string]: any;
}

const Section: React.FC<IProps> = ({ className, children, ...props }) => {
  return (
    <section className={cn('relative pt-20 lg:pt-40', className)} {...props}>
      {children}
    </section>
  );
};

export default Section;
